import { Link } from "react-router-dom";
import { ArrowRight, Youtube, Instagram, Twitter } from "lucide-react";
import { LogoWithText } from "../../Logo";

const Footer = () => {
  return (
    <footer className="bg-[#303030] text-bg-70 relative z-0">
      {/* Custom Grid Background for Footer */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `
            linear-gradient(to right, rgba(255,255,255,0.1) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255,255,255,0.1) 1px, transparent 1px)
          `,
          backgroundSize: `20px 20px`,
        }}
      />

      {/* Top Navigation */}
      <div className="border-b border-white/20 relative z-10">
        <div className="w-[90%] max-w-6xl mx-auto py-8">
          {/* Mobile Layout: Left and Right side by side */}
          <div className="flex justify-between lg:justify-between items-start gap-8">
            {/* Left Navigation */}
            <div className="flex flex-col gap-6 lg:flex-row lg:gap-8">
              <Link
                to="#features"
                className="text-white hover:text-white/80 transition-colors text-base font-medium"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .getElementById("features")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Feature
              </Link>
              <Link
                to="#plans"
                className="text-white hover:text-white/80 transition-colors text-base font-medium"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .getElementById("plans")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Pricing
              </Link>
              <Link
                to="/contact"
                className="text-white hover:text-white/80 transition-colors text-base font-medium"
              >
                Contact us
              </Link>
            </div>

            {/* Right Social Links */}
            <div className="flex flex-col gap-6 lg:flex-row lg:gap-8">
              <a
                href="https://www.youtube.com/@try_leebai"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white hover:text-white/80 transition-colors text-base font-medium"
              >
                <Youtube size={18} />
                Youtube
              </a>
              <a
                href="https://www.instagram.com/try_leebai"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white hover:text-white/80 transition-colors text-base font-medium"
              >
                <Instagram size={18} />
                Instagram
              </a>
              <a
                href="https://www.tiktok.com/@try_leebai"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white hover:text-white/80 transition-colors text-base font-medium"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.07 6.07 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                </svg>
                TikTok
              </a>
              <a
                href="https://x.com/try_leebai"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white hover:text-white/80 transition-colors text-base font-medium"
              >
                <Twitter size={18} />
                X
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-16 relative z-10">
        <div className="w-[90%] max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-8">
            <span className="text-white/60">Ready to experience the</span>
            <br />
            <span className="text-white">future of AI chat?</span>
          </h2>
          <Link
            to="/register"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-[#303030] rounded-full text-lg font-medium hover:bg-white/90 transition-colors"
          >
            Get Started
            <ArrowRight size={20} />
          </Link>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="border-t border-white/20 relative z-10">
        <div className="w-[90%] max-w-6xl mx-auto py-8">
          {/* Mobile Layout: Left and Right side by side */}
          <div className="flex justify-between items-end gap-8
">
            {/* Left Side - Logo and Legal Links */}
            <div className="flex flex-col gap-6 lg:col-span-2">
              {/* Logo */}
              <div className="flex justify-start">
                <LogoWithText
                  className="h-8 w-auto"
                  fillClassName="fill-white"
                />
              </div>

              {/* Legal Links */}
              <div className="flex flex-col gap-4 lg:flex-row lg:gap-8">
                {/* This link forces a full page refresh to land at the top on navigation */}
                <Link
                  to="/privacy-policy"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.assign("/privacy-policy");
                  }}
                  className="text-white hover:text-white/80 transition-colors text-sm"
                >
                  Privacy Policy
                </Link>
                {/* This link forces a full page refresh to land at the top on navigation */}
                <Link
                  to="/cookies-policy"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.assign("/cookies-policy");
                  }}
                  className="text-white hover:text-white/80 transition-colors text-sm"
                >
                  Cookies Policy
                </Link>
                {/* This link forces a full page refresh to land at the top on navigation */}
                <Link
                  to="/terms"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.assign("/terms");
                  }}
                  className="text-white hover:text-white/80 transition-colors text-sm"
                >
                  Terms and Condition
                </Link>

                {/* Refund Policy */}
                  <Link
                  to="/refund-policy"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.assign("/refund-policy");
                  }}
                  className="text-white hover:text-white/80 transition-colors text-sm"
                >
                  Refund Policy
                </Link>
              </div>
            </div>

            {/* Right Side - Contact Info */}
            <div className="flex flex-col gap-6 lg:col-span-2">
              <div>
                <p className="text-white/60 text-sm mb-2">Email</p>
                <a
                  href="mailto:info@leebai.com"
                  className="text-white hover:text-white/80 transition-colors text-sm"
                >
                  info@leebai.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
